$(document).ready(function () {
    /*========== Select Dropdown  ==========*/ 
    if ($('.language-select').length) {
        $('.language-select').niceSelect();
    }

    /*========== Off-canvas Menu  ==========*/
    // Open off-canvas menu
    $('#menu-toggle').on('click', function () {
        console.log('Menu toggled');
        $('#offcanvas-menu').addClass('active');
    });

    // Close off-canvas menu
    $('#close-btn').on('click', function () {
        console.log('Menu closed');
        $('#offcanvas-menu').removeClass('active');
    });

    // Close the off-canvas menu if clicking outside
    let debounce = false;
    $(document).on('click', function (event) {
        if (!debounce) {
            debounce = true;
            setTimeout(() => (debounce = false), 200);

            if (!$(event.target).closest('#offcanvas-menu, #menu-toggle').length) {
                $('#offcanvas-menu').removeClass('active');
            }
        }
    });

    // Toggle sub-menu for off-canvas menu
    $('.offcanvas-menu li.menu-item-has-children .toggle-submenu').on('click', function (e) {
        e.preventDefault(); // Prevent default action
        const $submenu = $(this).siblings('.sub-menu');
        $submenu.slideToggle(); // Toggle the submenu visibility
        $(this).parent().toggleClass('sub-active');

        // Accessibility updates
        const isExpanded = $(this).parent().hasClass('sub-active');
        $(this).attr('aria-expanded', isExpanded);
        $submenu.attr('aria-hidden', !isExpanded);
    });
});

